"use client";

import Image from "next/image";
import Button from "@/components/ui/Button";

export default function FeaturedFeature() {
  return (
    <section className="bg-white px-4 md:px-8 lg:px-16 xl:px-[100px]">
      <div style={{ maxWidth: "1228px", margin: "0 auto" }}>
        <div className="grid lg:grid-cols-2 gap-0">
          {/* Top-left: Reportes text */}
          <div
            className="flex flex-col justify-center p-8 lg:p-12 order-1 min-h-0 lg:min-h-[400px]"
            style={{ backgroundColor: "#344E41" }}
          >
            <h2
              className="mb-6 text-[32px] lg:text-[40px] leading-[40px] lg:leading-[50px]"
              style={{
                alignSelf: "stretch",
                color: "#FAFAFA",
                fontWeight: 400,
              }}
            >
              Reportes que hablan por tus cultivos
            </h2>
            <p
              className="mb-4 text-[16px] lg:text-[18px] leading-[24px] lg:leading-[28px]"
              style={{
                alignSelf: "stretch",
                color: "#FAFAFA",
                fontWeight: 400,
              }}
            >
              Convierte la información recolectada en reportes claros,
              visuales y listos para compartir. Gráficos, mapas temáticos y
              análisis comparativos transforman los datos en conocimiento,
              ayudándote a detectar tendencias, optimizar recursos y mejorar
              la productividad.
            </p>
            <p
              className="text-[16px] lg:text-[18px] leading-[24px] lg:leading-[28px]"
              style={{
                alignSelf: "stretch",
                color: "#FAFAFA",
                fontWeight: 400,
              }}
            >
              Obtén reportes se los datos al conocimiento en segundos:
              visualiza tendencias y toma decisiones con claridad.
            </p>
          </div>

          {/* Top-right: Image */}
          <div className="relative overflow-hidden order-2 lg:min-h-[400px]">
            <Image
              src="/images/004_Reportes que hablan por tus cultivos.webp"
              alt="Reportes que hablan por tus cultivos"
              width={614}
              height={400}
              className="w-full h-auto lg:h-full lg:object-cover"
            />
          </div>

          {/* Bottom-left: Image */}
          <div className="relative overflow-hidden order-4 lg:order-3 lg:min-h-[400px]">
            <Image
              src="/images/005_Bloomwise transforma tu forma de cultivar.webp"
              alt="Bloomwise transforma tu forma de cultivar"
              width={614}
              height={400}
              className="w-full h-auto lg:h-full lg:object-cover"
            />
          </div>

          {/* Bottom-right: Transformación text + button */}
          <div
            className="flex flex-col justify-center p-8 lg:p-12 order-3 lg:order-4 min-h-0 lg:min-h-[400px]"
            style={{ backgroundColor: "#526526" }}
          >
            <h2
              className="mb-6 text-[32px] lg:text-[40px] leading-[40px] lg:leading-[50px]"
              style={{
                alignSelf: "stretch",
                color: "#FAFAFA",
                fontWeight: 400,
              }}
            >
              Bloomwise transforma tu forma de cultivar
            </h2>
            <p
              className="mb-8 text-[16px] lg:text-[18px] leading-[24px] lg:leading-[28px]"
              style={{
                alignSelf: "stretch",
                color: "#FAFAFA",
                fontWeight: 400,
              }}
            >
              Digitaliza tu finca, mejora la trazabilidad y lleva tu
              productividad al siguiente nivel. Con Bloomwise tendrás
              siempre el control de tu campo, en cualquier momento y lugar.
            </p>
            <div>
              <Button
                variant="accent"
                size="lg"
                className="shadow-xl"
                style={{
                  color: "#FFF",
                  fontFamily: "Century Gothic",
                  fontSize: "20px",
                  fontWeight: 700,
                  lineHeight: "28px",
                }}
              >
                Solicita tu demo gratis
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
